export const enum EFileReaderError {
  READ_FILE_ERROR = "read_file_error",
}
